import React from 'react';
import { ASSETS } from '../constants/assets';
import { heatAreas, heatWarnings } from '../constants/mockData';
import { ChevronLeft, TrendingUp, AlertTriangle, MapPin, Info } from 'lucide-react';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { Card } from '../components/Card';
export function Heatmap() {
  return <div className="min-h-screen bg-[#EEF8F8] pb-10" data-id="element-222">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 h-20 bg-white flex items-center px-4 shadow-sm" data-id="element-223">
        <button onClick={() => window.history.back()} className="p-2 -ml-2" data-id="element-224">
          <ChevronLeft className="size-6 text-[#333333]" data-id="element-225" />
        </button>
        <h1 className="flex-1 text-center text-lg font-bold text-[#333333] mr-8" data-id="element-226">
          宿州文旅热图
        </h1>
      </header>

      <div className="pt-24 px-4 flex flex-col gap-6" data-id="element-227">
        {/* Map Visualization Placeholder */}
        <div className="relative h-80 w-full bg-white rounded-[48rpx] overflow-hidden shadow-lg border-4 border-white" data-id="element-228">
          <img src={ASSETS.heatmapSuzhouCity} alt="Heatmap Map" className="w-full h-full object-cover opacity-90" data-id="element-229" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-230" />

          {/* Floating Indicators */}
          <div className="absolute top-6 left-6 bg-white/90 backdrop-blur-md p-3 rounded-2xl shadow-xl flex items-center gap-2" data-id="element-231">
            <div className="size-3 bg-red-500 rounded-full animate-pulse" data-id="element-232" />
            <span className="text-xs font-bold text-[#333333]" data-id="element-233">实时监测中</span>
          </div>
        </div>

        {/* Heat Stats */}
        <div className="flex flex-col gap-4" data-id="element-234">
          <div className="flex items-center justify-between" data-id="element-235">
            <h2 className="text-xl font-bold text-[#333333]" data-id="element-236">区县热度排行</h2>
            <Badge variant="secondary" className="bg-white text-[#66CADA] border-none" data-id="element-237">
              今日数据
            </Badge>
          </div>

          <div className="grid grid-cols-1 gap-3" data-id="element-238">
            {heatAreas.map(area => <Card key={area.county} className="p-4 border-none shadow-sm flex items-center justify-between bg-white rounded-3xl" data-id="element-239">
                <div className="flex items-center gap-4" data-id="element-240">
                  <div className={`size-12 rounded-2xl flex items-center justify-center font-black text-lg ${area.heatScore > 80 ? 'bg-red-50 text-red-500' : 'bg-green-50 text-green-500'}`} data-id="element-241">
                    {area.heatScore}
                  </div>
                  <div data-id="element-242">
                    <h3 className="font-bold text-[#333333]" data-id="element-243">{area.county}</h3>
                    <p className="text-[20rpx] text-[#999999] mt-0.5 truncate max-w-[180px]" data-id="element-244">
                      {area.mainResource}
                    </p>
                  </div>
                </div>
                <Badge className={`${area.status === '热门' ? 'bg-red-500' : area.status === '升温' ? 'bg-orange-500' : 'bg-green-500'} text-white border-none px-3 py-1 rounded-lg`} data-id="element-245">
                  {area.status}
                </Badge>
              </Card>)}
          </div>
        </div>

        {/* Smart Warnings */}
        <div className="bg-orange-50 border border-orange-100 p-5 rounded-[40rpx] flex flex-col gap-3" data-id="element-246">
          <div className="flex items-center gap-2 text-orange-600" data-id="element-247">
            <AlertTriangle className="size-5" data-id="element-248" />
            <span className="font-bold" data-id="element-249">智能预警</span>
          </div>
          <div className="flex flex-col gap-2" data-id="element-250">
            {heatWarnings.map((warning, idx) => <div key={idx} className="flex gap-2" data-id="element-251">
                <div className="size-1.5 bg-orange-400 rounded-full mt-1.5 shrink-0" data-id="element-252" />
                <p className="text-sm text-orange-800 leading-relaxed" data-id="element-253">
                  {warning}
                </p>
              </div>)}
          </div>
          <Button className="mt-2 bg-orange-500 hover:bg-orange-600 text-white rounded-full font-bold" data-id="element-254">
            查看错峰路线
          </Button>
        </div>
      </div>
    </div>;
}